import React from 'react';
import { cn } from '../../utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  leftIcon?: React.ReactNode;
  rightSlot?: React.ReactNode;
}

const inputBase =
  'h-11 w-full rounded-control bg-card border border-line-strong text-ink placeholder:text-muted px-3 text-base ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:opacity-50 disabled:cursor-not-allowed';

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ invalid, leftIcon, rightSlot, className, ...rest }, ref) => {
    const input = (
      <input
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(inputBase, invalid && 'border-danger-text', leftIcon && 'pl-9', rightSlot && 'pr-9', className)}
        {...rest}
      />
    );

    if (!leftIcon && !rightSlot) return input;

    return (
      <div className="relative w-full">
        {leftIcon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted" aria-hidden="true">
            {leftIcon}
          </span>
        )}
        {input}
        {rightSlot && <span className="absolute right-3 top-1/2 -translate-y-1/2">{rightSlot}</span>}
      </div>
    );
  }
);
Input.displayName = 'Input';
